function camelToKebab(str: string) {
  return str.replace(/([A-Z0-9])/g, '-$1').toLowerCase();
}

function getBooleans({ booleans }: { booleans: string[] }) {
  const booleanClassName = booleans.map((key) => `sce-view-${camelToKebab(key)}`);
  return { booleanClassName };
}

function isBoolean(value: any) {
  return value === true;
}

export { getBooleans, isBoolean };
